@use '@/styles/tokens' as *;

.fields {
  display: flex;
  flex-direction: column;
  // Figma 944:564543 spaces the four field groups 24px apart; `<FormField>`'s own rhythm is 16px.
  gap: var(--space-6);

  // Figma 944:564548 puts the character counter below-right in 12px Text/Disabled; antd's default
  // is its own description tone.
  :global(.ant-input-data-count) {
    font-size: $font-size-12;
    color: var(--text-disabled);
  }
}

// `<FormField>` carries its own 16px `margin-bottom`, which would stack on top of the gap above.
// The class is doubled on purpose: `.field` and a bare `.fields > *` have the same specificity and
// the two rules land in different CSS chunks, so the tie would be settled by chunk load order
// rather than by intent.
.fields.fields > * {
  margin-bottom: 0;
}

// Figma 944:563818 draws the pre-selected Device at full-strength Text/Primary with the chevron
// still rendered, while 113581 A calls the field "disabled (locked)". The field is genuinely
// disabled; this restores the ink the design asks for.
//
// `&:global(...)`, not a descendant combinator: antd puts `ant-select-disabled` and this class on
// the *same* root element, so `.lockedDevice .ant-select-disabled` would never match anything.
// The value node is `.ant-select-content` — antd 6 renders the selected label there directly, and
// no longer emits v5's `.ant-select-selection-item` wrapper.
.lockedDevice:global(.ant-select-disabled) :global(.ant-select-content) {
  color: var(--text-primary);
}
